import React, { useEffect, useState } from "react";
import useQuery from "../lib/useQuery";
import { FormProvider, useForm } from "react-hook-form";
import Summary from "./Summary";
import Home from "./Home";
import { useAppContext } from "../context/AppContext";

import { zodResolver } from "@hookform/resolvers/zod";
import {
    defaultValues,
    formSchema,
} from "../lib/schemas";
import Basket from "./Basket";

const Configurator = () => {
    const query = useQuery();
    const page_type = query.get("type");

    const {
        state: { currentPage },
    } = useAppContext();



    const methods = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: defaultValues,
        mode: "onChange",
    });

    const render = (currentPage) => {
        switch (currentPage) {
            case "home":
                return <Home type={page_type} />;
            case "summary":
                return <Summary methods={methods} type={page_type} />;
            case "basket":
                return <Basket methods={methods} type={page_type} />;

            default:
                return <Home type={page_type} />;
        }
    };

    return <FormProvider {...methods}>{render(currentPage)}</FormProvider>;
};

export default Configurator;
